@switch (pageLayout()) {
  @case ('main') {
    <main-layout></main-layout>
  }

  @case ('blank') {
    <blank-layout></blank-layout>
  }
}

<palantir-toast></palantir-toast>

<app-debug-indicator></app-debug-indicator>

<!--
  Montado aqui, irmão do toast: `AppComponent` nunca é destruído, então a conversa
  com a Iara sobrevive a toda navegação. O gate de visibilidade fica DENTRO do
  componente — um `@if` aqui destruiria um turno em andamento.
-->
<app-iara-floating-chat></app-iara-floating-chat>
